<template>
  <div>
    <ConfigListItem
      label="Dicionário CAN"
      :value="strValue"
      :date="row && row.updatedAt"
      :login="row && row.updatedBy"
      @click="openEditDialog"
    />

    <ODialog ref="dialog" :hideWhenLoading="true">
      <v-card>
        <ODialogBar title="Dicionário CAN" @close="dismiss" />
        <v-card-text class="pa-6">
          <v-text-field
            class="pt-0 mt-0"
            autofocus
            filled
            v-model="txtFilter"
            placeholder="Buscar..."
            single-line
            hide-details
          />
        </v-card-text>

        <v-list class="maxh-4 py-0">
          <v-list-item
            class="px-6"
            v-for="opt in filteredDicts"
            :class="{ 'oderon lighten-1': opt.id == clonedValue }"
            :key="opt.id"
            @click="clonedValue = opt.id"
          >
            <v-list-item-title>
              <div class="d-flex align-center">
                {{ opt.name }}
                <v-spacer />
                <span class="tag grey rounded-pill text-caption"
                  >baud={{ opt.baudRate }}</span
                >
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>

        <!-- <v-card-text class="pa-6">
          <div class="d-flex flex-row">
            <OCapCont
              class="w-1/2 pa-2"
              label="BAUD Rate"
              :value="selectedOpt && selectedOpt.baudRate"
            />

            <OCapCont
              class="w-1/2 pa-2"
              label="Send ACK"
              :value="selectedOpt && selectedOpt.sendAck"
            />
          </div>
        </v-card-text> -->
        <ODialogButtons
          class="pa-6"
          txtApply="Salvar"
          @cancel="dismiss"
          @apply="save"
        />
      </v-card>
    </ODialog>
  </div>
</template>

<script>
import { CANDict } from '@/models'
import ConfigListItem from './ConfigListItem.vue'
import { matchAnyLike, atMost } from 'oderon-commons/src/utils'
import { getCfg, getManyCfgs } from './config-utils.js'

// usado aqui e na tela de cópia de configs
export function displayValue(allConfigs) {
  let value = getCfg(allConfigs, 'canDict')
  if (value == null) return '─'
  if (typeof value.valueOf() === 'string') value = JSON.parse(value)
  return atMost(value.name, 30)
}

export function copyValue(allConfigs) {
  let result = getManyCfgs(allConfigs, 'canDictId', 'canDict')
  if (result.canDict != null && typeof result.canDict.valueOf() === 'string') {
    result.canDict = JSON.parse(result.canDict)
  }
  return result
}

export default {
  components: { ConfigListItem },
  props: {
    allConfigs: { required: true }
  },
  data() {
    return {
      txtFilter: null,
      allDicts: [],
      clonedValue: null
    }
  },
  computed: {
    // Config correspondente ao canDictId no veículo
    row() {
      return this.allConfigs.find((x) => x.key == 'canDictId')
    },

    // CANDict correspondente ao row acima
    currentDict() {
      if (this.row == null || this.row.value == null) return null
      return this.allDicts.find((x) => x.id == this.row.value)
    },

    // Texto no list-item
    strValue() {
      return displayValue(this.allConfigs)
    },

    // O dicionário atualmente ESCOLHIDO NA POPUP (mas ainda não salvo)
    // Isto é usado para destacar baudRate/sendAck
    selectedOpt() {
      return this.allDicts.find((x) => x.id == this.clonedValue)
    },

    filteredDicts() {
      return this.allDicts.filter((x) => {
        // Sempre oculta inativos a menos que seja o item
        // atualmente definido.
        if (x.deletedAt != null) {
          if (x.id == this.row && this.row.value) return true
          return false
        }

        return matchAnyLike(this.txtFilter, x.name)
      })
    }
  },
  methods: {
    dismiss() {
      this.$refs.dialog.$dismiss()
    },
    openEditDialog() {
      this.clonedValue = this.row && this.row.value
      this.$refs.dialog.$loading(() => this.fetchDicts())
      return this.$refs.dialog.$open()
    },
    async fetchDicts() {
      // se o atual está inactive, tem que ser mostrado tb
      const { rows } = await CANDict.findAll({
        includeInactive: true,
        limit: 10000
      })
      this.allDicts = rows
    },
    async save() {
      const payload = { canDictId: this.clonedValue }
      if (payload.canDictId != null) {
        let dict = this.allDicts.find((x) => x.id == payload.canDictId)
        payload.canDict = {
          id: dict.id,
          name: dict.name,
          baudRate: dict.baudRate,
          sendAck: dict.sendAck
        }
      }
      this.$emit('save', payload)
      this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style lang="sass">
.selected-option
  background-color: #f7931e
</style>
